import * as deviceDetect from 'react-device-detect';

export function getFileExtension(filename) {
    return /[.]/.exec(filename) ? /[^.]+$/.exec(filename)[0] : undefined;
}

export function gup(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
    var regexS = "[\\?&]" + name + "=([^&#]*)";
    var regex = new RegExp(regexS);
    var results = regex.exec(url);
    return results == null ? null : results[1];
}

export function checkFileType(filename)  {
    var ext = getFileExtension(filename);
    if (!ext) {
        return "icon-file";
    }
    switch (ext.toLowerCase()) {
        case "zip":
        case "rar":
        case "7z":
        case "tar":
        case "gz":
            return "icon-file-archive";
        case "xlsx":
        case "xls":
        case "xlsm":
        case "xlsb":
        case "xltx":
        case "xml":
        case "csv":
        case "numbers":
            return "icon-file-excel";
        case "odt":
        case "txt":
        case "doc":
        case "docx":
        case "pages":
            return "icon-file-word";
        case "js":
        case "php":
        case "c":
        case "py":
        case "rb":
        case "html":
        case "go":
        case "css":
        case "config":
            return "icon-file-code";
        case "riff":
        case "wav":
        case "bwf":
        case "ogg":
        case "aiff":
        case "caf":
        case "raw":
        case "mp3":
        case "wma":
            return "icon-file-audio";
        case "pdf":
            return "icon-file-pdf";
        case "bmp":
        case "tiff":
        case "gif":
        case "jpeg":
        case "png":
        case "jpg":
        case "ico":
            return "icon-file-image-o";
        case "avi":
        case "mov":
        case "mpg":
        case "mp4":
        case "mkv":
        case "divx":
            return "icon-file-video";
        case "pptx":
        case "pptm":
        case "ppt":
            return "icon-file-powerpoint";
        default:
            return "icon-file";
    }
}

export async function checkDeviceAndBrowser() {
    const browserIsBrave = (navigator.brave && await navigator.brave.isBrave()) || false

	if (deviceDetect.isIOS) {
		if (parseInt(deviceDetect.osVersion) >= 13) {
			return true
		} else return false
	}

    if ((deviceDetect.isSafari || deviceDetect.isChrome || deviceDetect.isFirefox || deviceDetect.isEdge ||
        deviceDetect.isOpera || deviceDetect.isChromium || deviceDetect.isAndroid || (deviceDetect.isIE && deviceDetect.browserVersion >= 10) || browserIsBrave))
        return true;
    else
        return false;
}